function clear() {
  localStorage.clear();
}

function remove(key: string) {
  localStorage.removeItem(key);
}

function retrieve<T>({ key }: { key: string }): T | undefined {
  const value = localStorage.getItem(key);
  if (!value) {
    return undefined;
  }

  return JSON.parse(value) as T;
}

function save<T>({ key, data }: { key: string; data: T }) {
  localStorage.setItem(key, JSON.stringify(data));
}

const localStorageService = { clear, remove, retrieve, save };

export default localStorageService;
